import {EntityHistory} from "./EntityHistory";
import VehicleType from "./enums/VehicleType.js";
import {findEntityById, toFullEntityResult} from "./helpers/toFullEntityResult";
import {VehicleId} from "./nominalTypes/VehicleId";
import {AllPermitsResult} from "./types/AllPermitsResult";
import {FullEntityRelation} from "./types/EntityRelation";
import {PermitEntityResult, PermitFullEntityResult} from "./types/PermitEntityResult";
import {VehicleResult} from "./types/VehicleResult";

function createEmptyVehicle(vehicleId: VehicleId): VehicleResult {
	return {
		id: vehicleId,
		plate: vehicleId,
		type: VehicleType.Resident,
		attachments: [],
		customData: []
	}
}

function getSingle(permits: AllPermitsResult, permitResult: PermitEntityResult<VehicleId>): PermitFullEntityResult<VehicleId, VehicleResult>;
function getSingle(permits: AllPermitsResult, permitResult: PermitEntityResult<VehicleId> | undefined): PermitFullEntityResult<VehicleId, VehicleResult> | undefined {
	if (permitResult == null) {
		return undefined;
	}
	return toFullEntityResult(permits.vehicles, permitResult, createEmptyVehicle);
}

class Vehicles {
	static get(permits: AllPermitsResult, id: VehicleId): VehicleResult {
		return findEntityById(permits.vehicles, id, createEmptyVehicle);
	}

	static getAll(permits: AllPermitsResult, vehicleIds: VehicleId[]): VehicleResult[] {
		return vehicleIds.map(id => this.get(permits, id));
	}

	static getChanged(permits: AllPermitsResult, vehicles: PermitEntityResult<VehicleId>[]): FullEntityRelation<VehicleId, VehicleResult>[] {
		const result: FullEntityRelation<VehicleId, VehicleResult>[] = [];
		for (const relation of EntityHistory.allChanged(vehicles)) {
			const original = getSingle(permits, relation.original!);
			const changed = relation.changed && getSingle(permits, relation.changed);

			result.push({
				original: toFullEntityResult(permits.vehicles, original, createEmptyVehicle),
				changed: changed && toFullEntityResult(permits.vehicles, changed, createEmptyVehicle)
			});
		}

		return result;
	}

	static getPlatesByType(value: AllPermitsResult, type: VehicleType): string[] {
		return value.vehicles.filter(x => x.type === type).map(x => x.plate);
	}

	static getValid(permits: AllPermitsResult, vehicles: PermitEntityResult<VehicleId>[]): PermitFullEntityResult<VehicleId, VehicleResult>[] {
		return EntityHistory.allChanged(vehicles).map(e => getSingle(permits, e.original!));
	}
}

export {Vehicles};
